import React from 'react';
import { Grid, Card } from 'vindi-ds-components';
import Footer from './footer';
import PriceSimulator from './price_simulator';
import FormHeader from '../create/templates/form_header';
import FormFields from '../create/templates/form_fields';

function FormStructure({ headerTitle, footerTitle, footerSubtitle }) {
  return (
    <Grid container spacing={3} display='flex' justify='center'>
      <Grid item sm={7}>
        <Card padding='medium'>
          <FormHeader headerTitle={headerTitle} />
          <FormFields />
        </Card>
      </Grid>
      <Grid item sm={3}>
        <PriceSimulator />
      </Grid>
      <Footer subtitle={footerSubtitle} title={footerTitle} />
    </Grid>
  );
}

export default FormStructure;
